import axios from './axiosClient'
import { API_ENDPOINT } from '../constants/apis'
import type { FeatureFlagStatus } from '../constants/featureFlagStatus'

export const updateBackofficeVisibility = (
  definitionId: number,
  isBackofficeVisible: boolean
) => {
  return axios.patch(
    `${API_ENDPOINT}/settings/definitions/${definitionId}/visibility`,
    {
      is_backoffice_visible: isBackofficeVisible
    }
  )
}

export const updateSettingSubtext = (definitionId: number, subtext: string) => {
  return axios.patch(
    `${API_ENDPOINT}/settings/definitions/${definitionId}/subtext`,
    { subtext }
  )
}

export const updateSettingStatus = (
  definitionId: number,
  status: FeatureFlagStatus
) => {
  return axios.patch(
    `${API_ENDPOINT}/settings/definitions/${definitionId}/status`,
    { status }
  )
}
